import React, { useEffect, useState } from "react";
import InfoBanner from "./InfoBanner";
import { Button, Checkbox, Divider, Empty, Flex, Input, notification, Radio, Spin } from "antd";
import axios from "axios";
import { httpApi } from "api/http.api";
import _ from "lodash";
import { importProject } from "api/project.api";
import { SaveOutlined } from "@ant-design/icons";
import InfiniteScroll from "react-infinite-scroll-component";

const CreateProjectByATS = ({ onClose, setRefresh }: any) => {
  const [jobs, setJobs] = useState<any[]>([]);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [page, setPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number | null>(1);
  const [loading, setLoading] = useState<boolean>(false);
  const [formLoading, setFormLoading] = useState<boolean>(false);
  const [cancelToken, setCancelToken] = useState<any | null>(null);
  const [selectedProject, setSelectedProject] = useState<any | null>(null);

  const fetchData = async () => {
    setLoading(true);
    if (cancelToken) {
      // If there's a previous request, cancel it before making a new one
      cancelToken.cancel("New request initiated");
    }

    const newCancelToken = axios.CancelToken.source();
    setCancelToken(newCancelToken);

    try {
      const response = await httpApi.get(`/ats/job`, {
        params: { search: searchQuery, page },
        cancelToken: newCancelToken.token, // Provide the cancel token for this request
      });

      setJobs((prevJobs) => _.uniqBy([...prevJobs, ...response.data.results], "name"));
      setTotalPages(response.data.total_pages);
    } catch (error) {
      if (axios.isCancel(error)) {
        // Request was canceled, do nothing
        window.location.href = "/403";
      } else {
        console.error("Error fetching data:", error);
      }
    } finally {
      setLoading(false);
    }
  };
  const handleRadioChange = (projectName: any) => {
    setSelectedProject(projectName);
  };

  const handleCreateProject = async () => {
    if (!selectedProject) return;
    setFormLoading(true);
    try {
      const res = await importProject(selectedProject.job_id);
      notification.success({
        message: "Success",
        description: res.message ?? "Project imported successfully.",
      });
      setRefresh?.((refresh: number) => refresh + 1);
      onClose?.();
    } catch (error) {
      notification.error({
        message: "Import Failed",
        description: "An error occurred while importing the project.",
      });
      console.error("Error importing project:", error);
    } finally {
      setFormLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [searchQuery, page]);

  useEffect(() => {
    setJobs([]);
    setPage(1);
  }, [searchQuery]);

  return (
    <div className="create-project-wrapper bg-Filter-bg overflow-x-hidden overflow-y-auto">
      <InfoBanner title="Create a Project" description="Create by importing a project from ATS." />
      <div className="bg-white py-4">
        <h2 style={{ fontSize: "20px", marginBottom: "20px" }}>List of Projects</h2>
        <Input
          placeholder="Select an ATS project"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        {jobs.length > 0 ? (
          <Flex
            vertical
            gap={5}
            id="scrollableDiv"
            className="max-h-[40vh] overflow-y-auto mt-4 pr-2"
          >
            <InfiniteScroll
              dataLength={jobs.length}
              next={() => setPage((prev) => prev + 1)}
              hasMore={totalPages ? page < totalPages : false}
              loader={
                <div className="text-center py-2">
                  <Spin size="small" />
                </div>
              }
              endMessage={
                // <p style={{ textAlign: "center", marginTop: "10px" }}>
                //     <b>No more jobs</b>
                // </p>
                <></>
              }
              scrollableTarget="scrollableDiv"
            >
              <Radio.Group
                onChange={(e) =>
                  handleRadioChange(jobs.find((job) => job.job_id === e.target.value))
                }
                value={selectedProject?.job_id}
                style={{ width: "100%" }}
              >
                {jobs.map((job: any) => (
                  <div key={job.id}>
                    <Flex justify="space-between" className="py-2">
                      <Radio value={job.job_id} className="flex justify-center items-center">
                        {job.name}
                      </Radio>
                    </Flex>
                    <Divider className="m-0" />
                  </div>
                ))}
              </Radio.Group>
            </InfiniteScroll>
          </Flex>
        ) : !loading ? (
          <div className="pt-5">
            <Empty description="No Records Found" />
          </div>
        ) : loading ? (
          <div className="pt-5 w-full flex justify-center">
            <Spin size="default" />
          </div>
        ) : (
          ""
        )}
        <div
          className="flex space-x-2 justify-end ml-auto"
          style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}
        >
          <Button type="primary" onClick={handleCreateProject} disabled={!selectedProject}>
            {formLoading ? (
              <Spin spinning={formLoading} size="small" className="custom-spin" />
            ) : (
              <SaveOutlined />
            )}
            Add Project
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CreateProjectByATS;
